var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "762.000000pt",
    height: "1000.000000pt",
    viewBox: "0 0 762.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "dodgerblue",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5558 12776 c-295 -104 -530 -530 -578 -1046 -6 -63 -24 -664 -41 -1335 -54 -2207 -77 -3067 -81 -3071 -3 -2 -483 963 -1068 2145 -774 1564 -1077 2168 -1113 2217 -55 73 -142 143 -209 168 -39 15 -1295 307 -1443 336 -300 59 -621 -301 -733 -820 -44 -202 -33 145 -182 -5715 -33 -1303 -72 -2813 -86 -3355 -14 -542 -23 -1037 -20 -1100 11 -217 50 -381 132 -548 68 -139 160 -244 258 -292 46 -23 233 -69 781 -196 791 -182 785 -181 905 -135 277 106 516 547 560 1031 5 63 32 1031 60 2150 27 1119 53 2089 57 2154 l8 119 1064 -2150 c750 -1517 1078 -2170 1112 -2216 48 -64 124 -130 188 -162 31 -16 1394 -335 1494 -350 25 -4 71 -2 103 5 304 62 566 474 633 995 10 78 34 960 146 5350 30 1194 66 2609 80 3145 14 536 28 1090 31 1230 10 377 -22 588 -119 793 -55 117 -82 156 -153 229 -99 101 -101 101 -897 283 -441 101 -739 165 -770 165 -29 0 -82 -11 -119 -24z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.06a141932ff477a5ec17a88130af44c3.svg";
export { ForwardRef as ReactComponent };